/**
 * @class Channel
 */
export default class Channel {
    /**
     * @param {Number} id
     * @param {Number} specificWeight
     * @param {Object} colorant
     * @param {Boolean} enabled
     * @param {Number} volume
     */
    constructor(id, specificWeight, colorant, enabled, volume = 0) {
        this._id = id;
        this._specificWeight = specificWeight;
        this._colorant = colorant;
        this._enabled = enabled;
        this._volume = volume;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Channel");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {Number}
     */
    get specificWeight() {
        return this._specificWeight;
    }

    /**
     * @param {Number} specificWeight
     */
    set specificWeight(specificWeight) {
        this._specificWeight = specificWeight;
    }

    /**
     * @return {Object}
     */
    get colorant() {
        return this._colorant;
    }

    /**
     * @param {Object} colorant
     */
    set colorant(colorant) {
        this._colorant = colorant;
    }

    /**
     * @return {Boolean}
     */
    get enabled() {
        return this._enabled;
    }

    /**
     * @param {Boolean} enabled
     */
    set enabled(enabled) {
        this._enabled = enabled;
    }

    /**
     * @return {Number}
     */
    get volume() {
        return this._volume;
    }

    /**
     * @param {Number} volume
     */
    set volume(volume) {
        this._volume = volume;
    }

    /**
     * @return {Object}
     */
    clone() {
        return new Channel(this._id, this._specificWeight, this._colorant, this._enabled, this._volume);
    }

    /**
     * @return {String}
     */
    toString() {
        return "Channel (" + this._id + ")";
    }
}
